import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bidi-avatar-selector',
  templateUrl: './avatar-selector.component.html',
  styleUrls: ['./avatar-selector.component.scss']
})
export class AvatarSelectorComponent implements OnInit {


  @Output() selectorState: EventEmitter<boolean> = new EventEmitter;
  state: boolean;

  constructor() { }

  ngOnInit() {
  }

  closeAvatarSelector() {
    this.state = false;
    this.selectorState.emit(this.state);
  }
}
